export default "55f10f889ceb2d06.svg"